import { render, staticRenderFns } from "./InviteJobDescription.vue?vue&type=template&id=372cbb8a&scoped=true"
import script from "./InviteJobDescription.vue?vue&type=script&lang=js"
export * from "./InviteJobDescription.vue?vue&type=script&lang=js"
import style0 from "./InviteJobDescription.vue?vue&type=style&index=0&id=372cbb8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372cbb8a",
  null
  
)

export default component.exports